import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import css from './BlogSection.module.css';
import Tile from '../Tile/Tile';
import Button from '../Button/Button';
import { getLatestBlogPosts } from '../../utils';

const BlogSection = () => {
  const history = useHistory();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getLatestBlogPosts(5)
      .then(posts => {
        setArticles(posts);
        setLoading(false);
      })
      .catch(e => {
        console.error('Error loading blog posts:', e);
        setLoading(false);
      });
  }, []);

  const getImageUrl = (post) => {
    if (post.image?.formats?.large?.url) {
      return post.image.formats.large.url;
    }
    if (post.image?.formats?.medium?.url) {
      return post.image.formats.medium.url;
    }
    if (post.image?.url) {
      return post.image.url;
    }
    return '/static/img/rectangle-4-15.png'; // fallback image
  };

  return (
    <div className={css.section}>
      <div className={css.header}>
        <p className={css.title}>
          Blogs, Stories, Tips & Community Insights
        </p>

        <p className={css.description}>
          Explore our latest articles on martial arts training, community
          impact, second-hand gear advice, and inspiring journeys from people
          in the Grounddz network.
        </p>
      </div>

      {loading ? (
        <div className={css.loadingContainer}>
          <p className={css.loadingText}>Loading articles...</p>
        </div>
      ) : (
        <div className={css.tilesContainer}>
          {articles.map(article => (
            <Tile
              key={article.id}
              variant="landscape"
              image={getImageUrl(article)}
              articleTitle={article.title}
              onClick={() => history.push(`/post/${article.slug}`)}
            />
          ))}
        </div>
      )}

      <div className={css.buttonWrapper}>
        <Button
          className={css.exploreButton}
          variant="primary"
          text="Explore all articles"
          onClick={() => history.push('/blog')}
        />
      </div>
    </div>
  );
};

export default BlogSection;

